import React, { useContext } from 'react';
import { LanguageContext } from '../../../Contexts/LanguageContext';
import './CareerDetails.css';

const CareerDetails = () => {
    const [isBangla, setIsBangla] = useContext(LanguageContext)
    return (
        <div className="career-details container">
            <div className="container mb-5">
                <h1 className='text-center mt-5' style={{ fontSize: '55px' }}>{isBangla ? "আপনার সৃজনশীলতা প্রকাশ করুন" : "Unleash your Creativity"}</h1>
            </div>
        </div>
    );
};

export default CareerDetails;